module.exports = "/assets/c8c10bd9f89b5904f58c685e7753949a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DE.png
// module id = 2425
// module chunks = 0